import { render, staticRenderFns } from "./questionnaireStatistics.vue?vue&type=template&id=ca68ec66&scoped=true"
import script from "./questionnaireStatistics.vue?vue&type=script&lang=js"
export * from "./questionnaireStatistics.vue?vue&type=script&lang=js"
import style0 from "./questionnaireStatistics.vue?vue&type=style&index=0&id=ca68ec66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca68ec66",
  null
  
)

export default component.exports